<template>
    <div id="pz">
     <div class="dokpz">
        <div class="title">{{ title }}</div>
	<div class="items">
		<div id='container' class='e-resizable'>
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="false" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected="rowSelected" :rowDeselected="rowSelected" :allowTextWrap='true' locale='pl-PL' :allowFiltering="true" :filterSettings="filterOptions" :rowHeight="80" height="100%" width="100%"> 
			<e-columns>
				<e-column field='ID_DOK_MAGAZYNOWEGO' headerText='ID' :visible="false"></e-column>
				<e-column field='numerPZ' headerText='Numer PZ' width='80'></e-column>
				<e-column field='dataPZ' headerText='Data PZ' type='date' format='yyyy-MM-dd' width='80'></e-column>
				<e-column field='nazwaKontrahenta' headerText='Nazwa kontrahenta' width='200'></e-column>
				<e-column field='ID_ARTYKULU' headerText='ID Artykułu' width='100' :visible="false"></e-column>
				<e-column field='nazwaArtykulu' headerText='Nazwa artykułu' width='120'></e-column>
            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
		</div>
	</div>
     </div>
     <div class="wleft">
        <button class="wlabel"> WRÓĆ </button>
     </div>
     <div class="wright">
	<button class="wlabel"> DODAJ OPAKOWANIE </button>
     </div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
//import { L10n, setCulture } from '@syncfusion/ej2-base';
import { dokumenty_pz } from "./panel1_dane.js";
import * as CONFIG from "./config.js";
import axios from "axios";
import { polish } from "./polish.js";
import Storage from "./Storage";

//setCulture('pl-PL');

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);


export default {
  name: "dokumentypzprzyp",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: dokumenty_pz.items,
	data: [],
	url: "/agent/GALEK.Magazyn/GetDokumentPZPrzypisane",
	title: "ODSORTY > ZLECENIA > ODSORTY > LISTA DOKUMENTÓW PZ",
	x: 1,
        pageSettings: { pageSize: 5 },
	selectionOptions: { type: 'Multiple', enableSimpleMultiRowSelection: true, allowColumnSelection: false },
	gitem: [],
	filterOptions: {
        type: 'Menu',
        operators: {
          stringOperator: [
            { value: 'startsWith', text:'startsWith' },
            { value: 'endsWith', text:'endsWith' },
            { value: 'contains', text:'contains' }
          ],
        }
	},
	jwt: "",
	id_zlecenia: -1,
	id_odpadu: -1,
   }),
   provide: {
	grid: [Page, Sort, Filter]
   },
   methods: { 
	dataBound: function() {
        	//this.$refs.grid.autoFitColumns();
    	},
	rowSelected(args) {
        	//let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
        	//alert(selectedrowindex); // To alert the selected row indexes.
        	let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		if (selectedrecords.length > 0) {
			this.gitem = selectedrecords;		
			//alert(JSON.stringify(this.gitem));
		} else {
			this.gitem = [];

		}
	},
	drukujclick() {
		//alert("Drukuj");
		if (this.gitem.length > 0) {
                        var mags = "" + this.gitem[0].ID_DOK_MAGAZYNOWEGO;
                        if (this.gitem.length > 1) {
                                for (var i = 1; i < this.gitem.length; i++) {
                                        mags += "," + this.gitem[i].ID_DOK_MAGAZYNOWEGO;
                                }
                        }
			this.$router.push({ path: "/odpadyopakowanie", query: { mag: mags, id_zlecenia: this.id_zlecenia, id_odpadu: this.id_odpadu, prev: "odpadypz" }});
		} else {
			alert("Nie wybrano elementu zlecenie. Proszę zaznaczyć dokładnie 1 element z listy.");
		}
	},
	wrocclick() {
		this.$router.push({ path: "/odpady", query: { id_zlecenia: this.id_zlecenia }});
	},
	getData() {
      		return axios
        		.get(CONFIG.API_URL + this.url + "/" + this.id_zlecenia, {
          		headers: {
            			"Content-Type": "application/x-www-form-urlencoded",
            			"Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
          		}
        		})
        		.then(response => {
          			return response.data;
        		})
        		.catch(e => {
          			alert("ERROR" + e);
        		});
	},
   },
   mounted() {
	var that = this;
	var params = this.$route.query;
        if (params["id_zlecenia"]) {
                this.id_zlecenia = params["id_zlecenia"];
        }
        if (params["id_odpadu"]) {
                this.id_odpadu = params["id_odpadu"];
        }
	Storage.loadJWT("jwt").then(resp => {
		//alert(resp.access_token);
		that.jwt = resp.access_token;
		that.getData().then(data => {
			that.data = data;
		});
	});
	document.querySelector(".wright").addEventListener('click', function() { that.drukujclick(); } );
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.title {
	text-align: left;
	width: 100%;
}
.items {
	float:none;
}
.dokpz {
	float: left;
	width: 96%;
	padding: 2% 2% 0% 2%;
}
.wright {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// src/components/DokumentPZOdpady.vue